// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"303":"2c70f2ba","418":"20b66b07","675":"4a768a74","887":"1e696c6c"}[chunkId] + ".chunk.js";
};